export default __webpack_public_path__ + "static/summer_containers47-73ae2f55d946e723a165d09b6bfecdf2.webp";